"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconBin = function IconBin(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M6.743 8.071a2 2 0 0 0 0 2.829l.057.056 5.609-5.704-.009-.01a2 2 0 0 0-2.828 0zm6.373-2.112-5.609 5.705 4.893 4.892a3 3 0 0 1 4.243 0l2.12-2.121a2 2 0 0 0 0-2.828zm4.4 12.552 2.662-2.662a4 4 0 0 0 0-5.657l-6.364-6.364a4 4 0 0 0-5.657 0L5.33 6.657a4 4 0 0 0 0 5.657l.069.069L4.79 13H3v1h2.21l.895-.91 5.421 5.42a3 3 0 1 0 5.99 0m-1.158-.627a2 2 0 0 0-.411-.61l-.011-.01a2 2 0 1 0 .422.62m-1.595-8.086-.707.707 2.828 2.829.707-.707z",
    clipRule: "evenodd"
  })));
};

export { IconBin, IconBin as default };
